import { UTILS } from '@cms/tpl';
import { Tag } from 'antd';
import React from 'react';
const MonopolyType = {
  DQ01: [1, 'DQ-A', <Tag color={UTILS.COLOR.GREEN}>DQ-A</Tag>],
  DQ02: [2, 'DQ-B', <Tag color={UTILS.COLOR.YELLOW_ORANGE}>DQ-B</Tag>],
  DQ03: [3, 'DQ-C', <Tag color={UTILS.COLOR.ORANGE}>DQ-C</Tag>],
};
export default MonopolyType;
